export default "__VITE_ASSET__r2fGqR8F__"